import { render } from "./index.vue?vue&type=template&id=436f38cf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=436f38cf&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436f38cf"],['__file',"src/components/CadastroDeFases/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "436f38cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('436f38cf', __exports__)) {
    console.log('reload')
    api.reload('436f38cf', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=436f38cf&scoped=true", () => {
    console.log('re-render')
    api.rerender('436f38cf', render)
  })

}


export default __exports__